'use es6';

export const avatarStateAttributesMapping = {
  imageLoadingStatus: () => null
};